import { Wordmark } from '@/components/ui/wordmark';

export function FullPageSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideShimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
      <div
        className="flex flex-col items-center gap-4"
        style={{ animation: 'fadeIn 400ms ease forwards' }}
      >
        <Wordmark />
        <div className="w-[120px] h-[2px] rounded-full bg-primary/20 overflow-hidden">
          <div
            className="h-full w-1/2 rounded-full bg-primary"
            style={{ animation: 'slideShimmer 1.2s ease-in-out infinite' }}
          />
        </div>
        <p className="text-xs text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
